import { Box, Popover, Tooltip, Typography, useTheme } from '@mui/material';
import * as React from 'react';
import { useGateMainContext } from './GateMainContext';
import UsersPopup from './UsersPopup';
import LanguagePicker from './Shared/LanguagePicker';
import { useTranslation } from 'react-i18next';

export interface IUpperMenuProps {
    showChangeTenantDialog: () => void;
}

export default function UpperMenu(props: IUpperMenuProps) {
    const { showChangeTenantDialog } = props;
    const { userData, logo, branding } = useGateMainContext();
    const [anchorEl, setAnchorEl] = React.useState<HTMLDivElement | null>(null);
    const openDropDownUserMenu = Boolean(anchorEl);
    const dropDownId = openDropDownUserMenu ? 'simple-popover' : undefined;
    const { t } = useTranslation();

    function showTenants() {
        setAnchorEl(null);
        showChangeTenantDialog();
    }

    return (
        <Box px={4} display='flex' alignItems='center' justifyContent='space-between' sx={{ height: 56, width: '100%', bgcolor: 'background.default', position: 'fixed', boxShadow: 4, borderBottom: '1px solid', borderColor: 'divider' }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                {logo && (
                    <Box component="img" src={logo} alt={userData?.tenantName ?? 'Tenant logo'} sx={{ height: 30, width: 'auto', minWidth: 88, maxWidth: 220, objectFit: 'contain' }} />
                )}
                <Box>
                    <Box><Typography fontSize='14px' color='primary' fontWeight='bold'>{branding?.brandName?.trim() || 'SG WebTools'}</Typography></Box>
                    <Box><Typography fontSize='10px' color='text.secondary'>{t('AppPortal')}</Typography></Box>
                </Box>
            </Box>
            <Box display='flex' alignItems='center' pr={6}>
                <LanguagePicker showText={false} />
                <Box mr={2} sx={{ fontSize: '14px', textAlign: 'right', mt: 0.5 }}>
                    <Box component="div" sx={{ color: 'text.primary' }}>{userData?.firstName}{' '}{userData?.lastName}</Box>
                    <Box component="div" sx={{ fontWeight: 'bold', marginTop: '-4px', color: 'primary.main' }}>{userData?.tenantName}</Box>
                </Box>
                <Tooltip title={t('UsersPopup.UsersProfile') + userData?.firstName + ' ' + userData?.lastName}>
                    <Box className='user-button'
                        onClick={(e) => { setAnchorEl(e.currentTarget); }}
                    >{userData?.initials}</Box>
                </Tooltip>
                <Popover
                    id={dropDownId}
                    slotProps={
                        {
                            paper: {
                                sx: { border: '1px solid', borderColor: 'divider', borderRadius: '16px', background: 'background.paper' }
                            }
                        }
                    }

                    sx={{ zIndex: 50002 }}
                    open={openDropDownUserMenu}
                    anchorEl={anchorEl}
                    onClose={() => { setAnchorEl(null) }}
                    anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'right',
                    }}
                >
                    <div className="popup-content-div" >
                        <UsersPopup showChangeTenantDialog={showTenants} />
                    </div>
                </Popover>
            </Box>
        </Box>
    );
}
